import { Pipe, PipeTransform } from '@angular/core'
import { LocaleService } from 'framework/locale/services/locale.service'
import defaultTranslations from './option-translations'

interface TransformParam {
    optionName: string
    key: string
    selectableOptionId?: string
}

@Pipe({ name: 'optionTranslation' })
export class OptionTranslationPipe implements PipeTransform {
    private localeTranslations: { [key: string]: string }

    constructor(private localeService: LocaleService) {
        this.localeTranslations = {
            ...(defaultTranslations[this.localeService.language] || {}),
            ...(defaultTranslations[this.localeService.locale] || {}),
        }
    }

    async transform({ optionName, key, selectableOptionId = '' }: TransformParam): Promise<string> {
        const translationKey =
            key === 'optionLabel' || key === 'optionDescription'
                ? `deal-option-${optionName}-${key}-${selectableOptionId}`
                : `deal-option-${optionName}-${key}`

        let translation = ''

        if (this.localeTranslations[translationKey]) {
            translation = this.localeTranslations[translationKey]
        }

        if (window['mgTranslations'] && window['mgTranslations'][translationKey]) {
            translation = window['mgTranslations'][translationKey]
        }

        return translation
    }
}
